import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiX } from 'react-icons/fi';

const SearchModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [isOpen]);

  const handleSearch = () => {
    if (!searchQuery.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    onClose();
    setSearchQuery('');
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[2000] flex items-start bg-black/40 backdrop-blur-sm" 
      onClick={onClose}
    >
      <div 
        className="w-full bg-[#f4f4f4] py-8 px-4 flex justify-center items-center shadow-md animate-fade-in" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full max-w-[1200px] flex items-center justify-center gap-4">
          
          <div className="relative w-full max-w-[850px]">
            <input
              ref={inputRef}
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              className="w-full py-3.5 px-5 pr-14 border border-gray-400 bg-white text-[15px] text-gray-800 focus:outline-none focus:border-gray-900 transition-colors"
            />
            <button 
              onClick={handleSearch}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-600 hover:text-black transition-colors"
            >
              <FiSearch size={22} />
            </button>
          </div>

          <button 
            onClick={onClose} 
            className="text-gray-600 hover:text-black transition-colors p-2 flex-shrink-0"
          >
            <FiX size={28} strokeWidth={1.5} />
          </button>
          
        </div>
      </div>
    </div>
  );
};

export default SearchModal;